<template lang="pug">
.tela-cheia
    #diagnostico-socioambiental-territorio-view
        .card-socioambiental
            .dados
                header.mb-4
                    h1
                        .el-icon-arrow-left.voltar(@click='$router.go(-1)')
                        | {{ $t('mensagens.diagnosticoSocioambiental.titulo') }}

                section
                    h3.mb-3
                        .dados-label
                            i.flow.flow-shape
                            b {{ $t('') }}{{ $t('mensagens.diagnosticoSocioambiental.territorio') }}
                        span {{ territorio.dadosTerritorio.nome }}

                    header(v-if='informacoes_gerais !== null')
                        p.mt-2.mb-3 {{ $t('mensagens.comuns.informacoesGerais') }}:
                        h4.pl-3.informacoes-gerais(
                            v-if='informacoes_gerais.area_ha'
                        ) {{ $t('mensagens.diagnosticoSocioambiental.areaHa') }}: {{ informacoes_gerais.area_ha }}
                        h4.pl-3.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.bioma') }}: {{ informacoes_gerais.bioma ? informacoes_gerais.bioma : '--' }}
                        h4.pl-3.informacoes-gerais {{ $t('mensagens.diagnosticoSocioambiental.faixaDeFronteira') }}: {{ informacoes_gerais.faixa_fronteira !== null ? (informacoes_gerais.faixa_fronteira ? $t('mensagens.comuns.sim') : $t('mensagens.comuns.nao')) : '--' }}

                    header
                        p.mt-2 {{ $t('mensagens.diagnosticoSocioambiental.resultadoDaAnalise') }}
                    DiagnosticoSocioambiental(
                        ref='refDiagnosticoSocioambiental',
                        v-if='refMapa',
                        :dadosConsulta='territorio',
                        :habilitar-opacidade='true',
                        @index-aberto='atualizarRestricaoMapa',
                        :mapaLeaflet='refMapa',
                        :habilitar-zoom-restricao='true'
                    )

                section.mt-3(v-if='territorio.buffer')
                    h3.mb-3
                        i.el-icon-connection
                        b {{ tituloProximidade }}
                    DiagnosticoSocioambiental(
                        ref='refDiagnosticoSocioambientalProximidade',
                        v-if='refMapa',
                        :dadosConsulta='territorio.buffer',
                        :habilitar-opacidade='true',
                        :habilitar-sinal-aviso='territorio.buffer.habilitarAlertaProximidade',
                        @index-aberto='atualizarRestricaoBufferMapa',
                        :mapaLeaflet='refMapa',
                        :habilitar-zoom-restricao='true'
                    )

                section.mt-5(v-for='(representante, index) in representantes')
                    h3.mb-3
                        .dados-label
                            i.flow.flow-user-second
                            b {{ $t('mensagens.comuns.pessoa') }}
                        span {{ representante.nomeRepresentante }}
                    DiagnosticoSocioambiental(
                        :ref='"refDiagnosticoSocioambientalRepresentante_" + index',
                        v-if='refMapa',
                        :indexCollapse='index',
                        :dadosConsulta='representante',
                        :cpfCnpj='representante.documento',
                        :habilitar-opacidade='true',
                        @index-aberto='atualizarRestricaoMapaCpf',
                        :mapaLeaflet='refMapa',
                        :habilitar-zoom-restricao='true'
                    )

                section.mt-5(v-for='(car, index) in dadosCar')
                    h3.mb-3
                        .dados-label
                            i.flow.flow-shape
                            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.car') }}
                        span {{ car.imovel.codigo }}
                    DiagnosticoSocioambiental(
                        ref='refDiagnosticoSocioambientalCar',
                        v-if='refMapa',
                        :mapaLeaflet='refMapa',
                        :indexCollapse='index',
                        :dadosConsulta='car',
                        :habilitar-opacidade='true',
                        :car='getCar(car.imovel.codigo)',
                        @index-aberto='atualizarRestricaoMapaCars',
                        :habilitar-zoom-restricao='true'
                    )

                section.mt-5(
                    v-if='!dadosCar.length && territorio.dadosTerritorio.cars && territorio.dadosTerritorio.cars.length'
                )
                    h3.mb-3
                        .dados-label
                            i.flow.flow-shape
                            b {{ $t('mensagens.comuns.carsVinculados') }}

                    div(
                        v-for='(car, index) in territorio.dadosTerritorio.cars'
                    )
                        p <b>Código:</b> {{ car.codigo }}
                        p <b>Situação:</b> "{{ car.condicao }}"

                    .buscarCars
                        el-link(
                            type='primary',
                            :underline='false',
                            @click='buscarDiagnosticoCars'
                        )
                            | {{ $t('mensagens.diagnosticoSocioambiental.realizarDiagnosticoDosCarsVinculados') }}

            .exportar-btn
                el-dropdown.float-right.my-3
                    el-button(
                        type='primary',
                        @click='marcarExportacaoDiagnosticPdf'
                    ) {{ $t('mensagens.diagnosticoSocioambiental.marcarParaExportacao') }}

                el-dropdown.float-right.my-3(v-bind:disabled='loadingPDF')
                    el-button(
                        type='primary',
                        @click='!hasDadosConsultaBuffer ? exportarPdfDiagnosticoSocio(false) : undefined'
                    )
                        i.el-icon-loading(v-if='loadingPDF')
                        span {{ $t('mensagens.diagnosticoSocioambiental.exportarDiagnostico') }}

                    el-dropdown-menu.downloadMenu(
                        v-if='hasDadosConsultaBuffer',
                        slot='dropdown'
                    )
                        el-dropdown-item
                            el-button(
                                type='primary',
                                @click='exportarPdfDiagnosticoSocio(false)',
                                icon='el-icon-download'
                            ) {{ $t('mensagens.diagnosticoSocioambiental.territorio') }}

                        el-dropdown-item.spaceProximidades
                            el-button(
                                type='primary',
                                @click='exportarPdfDiagnosticoSocio(true)',
                                icon='el-icon-download'
                            ) {{ $t('mensagens.diagnosticoSocioambiental.territorioProximidades') }}

        .mapa.w-100.h-100
            mapa(
                ref='mapa',
                :showStatesLayers='false',
                :mapLayersConfigs='layersMaps',
                :mapConfig='mapConfig',
                :height='"100%"',
                :idMapa='"mapaDiagnosticoSocioambiental"',
                :atualizarMapa='true'
            )
</template>

<script>
import L from 'leaflet';
import Mapa from '@/components/MapaLeaflet.vue';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import TerritorioService from '@/services/TerritorioService';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import { sortBy } from 'lodash';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';

import { retryOperation } from '@/utils/retry-operation';
import { mapActions, mapGetters } from 'vuex';
import EventBus from '@/utils/eventBus';
import formatters from '@/utils/formatters';
import { connect, subscribe, disconnect } from '@/utils/websocket';

import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';

export default {
    name: 'DiagnosticoSocioambientalTerritorioView',

    components: {
        Mapa,
        DiagnosticoSocioambiental
    },

    data() {
        return {
            territorio: {
                dadosTerritorio: {},
                diagnosticos: [],
                buffer: null
            },
            representantes: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                },
                inspecionar: true
            },
            pesquisaValida: true,
            areasRestricao: [],
            loadingPDF: false,
            dadosCar: [],
            indexUltimaRestricaoAbertaTerritorio: null,
            indexUltimaRestricaoAbertaTerritorioBuffer: null,
            indexUltimaRestricaoAbertaRepresentante: null,
            indexUltimaRestricaoAbertaCar: null,
            informacoes_gerais: null,
            camadasAtivas: [],
            camadasGeoserver: [],
            dadosConsulta: {},
            pesquisa: '',
            tituloProximidade: '',
            refMapa: null,
            refComponentesDiagnosticos: [
                'refDiagnosticoSocioambiental',
                'refDiagnosticoSocioambientalProximidade',
                'refDiagnosticoSocioambientalCar'
            ]
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado']),

        hasDadosConsultaBuffer() {
            return this.territorio.buffer !== null;
        }
    },

    created() {
        EventBus.$off('mapa:buffer-click');
        this.$nextTick(function () {
            EventBus.$on('mapa:buffer-click', this.bufferClick);
        });
    },

    async mounted() {
        this.refMapa = this.$refs.mapa;
        this.$bus.$on('mapa:camadas-ativas-diagnostico', data => {
            this.camadasAtivas = [];
            data.map(layer => {
                this.camadasAtivas.push(layer.layerName);
            });
        });

        const idTerritorio = this.$route.params.idTerritorio;

        await this.buscarDiagnosticoTerritorio(idTerritorio);

        await this.buscarDiagnosticoRepresentantes(idTerritorio);

        this.$bus.$emit('mapa:show-buffer', true);
    },

    methods: {
        ...mapActions(['setMarcarExportar_PDF']),

        getCar(car) {
            if (car.toUpperCase().startsWith('PA')) {
                return car;
            }
        },

        async bufferClick() {
            try {
                this.fecharTodosCollapsesAbertos();
                const response =
                    await DiagnosticoSocioambientalService.analisarBuffer(
                        [
                            JSON.stringify(
                                this.territorio.dadosTerritorio.geometria
                            )
                        ],
                        this.territorio.idDiagnosticoSocioambiental
                    );

                const diagnosticos = [];
                response.data.dados.forEach(d =>
                    d.forEach(t => {
                        diagnosticos.push(t);
                    })
                );

                const geometrias = [];
                response.data.geometrias.forEach(g => {
                    geometrias.push(JSON.parse(g));
                });

                this.territorio.buffer = {
                    diagnosticos: diagnosticos,
                    geometria: geometrias,
                    habilitarAlertaProximidade:
                        response.data.habilitarAlertaProximidade
                };

                this.tituloProximidade = response.data.tituloProximidade;

                this.mostrarLayersBufferMapa();
            } catch (e) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.buscarDadosBuffer'
                    )
                });
            }
        },

        fecharTodosCollapsesAbertos() {
            /**
             * Fecha todos os collapses
             * caso estejam abertos
             * Território/CAR/Representantes
             */
            this.refComponentesDiagnosticos.forEach(item => {
                const ref = this.$refs[item];
                if (ref && ref.length) {
                    ref[0].indexCollapseRow = '';
                } else if (ref) {
                    ref.indexCollapseRow = '';
                }
            });

            this.representantes.forEach((_, index) => {
                const refItem = `refDiagnosticoSocioambientalRepresentante_${index}`;
                const ref = this.$refs[refItem];

                if (ref && ref.length) {
                    ref[0].indexCollapseRow = '';
                } else if (ref) {
                    ref.indexCollapseRow = '';
                }
            });
        },

        configureLayersMapa() {
            this.layersMaps.push({
                style: getEstiloGeometria('area'),
                name: this.$t(
                    'mensagens.monitoramento.historico.agricola.areaMonitorada'
                ),
                geoJson: this.territorio.dadosTerritorio.geometria,
                tooltip: 'Território: ' + this.territorio.dadosTerritorio.nome,
                featureGroup: true
            });
        },

        mostrarLayersBufferMapa() {
            this.layersMaps.push({
                style: getEstiloGeometria('area'),
                name: this.$t(
                    'mensagens.monitoramento.historico.agricola.areaMonitorada'
                ),
                geoJson: this.territorio.buffer.geometria,
                featureGroup: true
            });
            this.$bus.$emit('mapa:show-buffer', false);
        },

        carVinculadoLayersMapa(value, car) {
            this.layersMaps.push({
                style: getEstiloGeometria('car'),
                name: this.$t('mensagens.operacao.carVinculado'),
                geoJson: value,
                tooltip: 'Car: ' + car,
                featureGroup: true
            });
        },

        carsVinculadosLayersMapa(dadosCar) {
            dadosCar.forEach(dadoCar => {
                this.layersMaps.push({
                    style: getEstiloGeometria('car'),
                    name: this.$t('mensagens.operacao.carVinculado'),
                    geoJson: dadoCar.imovel.geometria,
                    tooltip: 'Car: ' + dadoCar.imovel.codigo,
                    featureGroup: true
                });
            });
        },

        mostrarAreasDiagnosticoNoMapa(tagRestricao, group, name, restricao) {
            const opacidade =
                this.areasRestricao.camada.opacidade >= 0.0
                    ? this.areasRestricao.camada.opacidade / 200
                    : 0.5;

            this.areasRestricao.areas.forEach((area, index) => {
                if (area) {
                    this.layersMaps.push({
                        style: {
                            color: 'red',
                            weight: 1,
                            fill: true,
                            opacity: opacidade,
                            fillOpacity: opacidade
                        },
                        name: `${name}_${index}`,
                        tagRestricao,
                        group,
                        geoJson: area
                    });

                    const pin = L.icon({
                        iconUrl:
                            'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                        iconSize: [18, 18]
                    });

                    this.layersMaps.push({
                        name: `CentroidDiagnostico ${index}`,
                        icon: pin,
                        tagRestricao,
                        group,
                        geoJson: centroidFromGeoJSON.get(area)
                    });
                }
            });
        },

        async exportarPdfDiagnosticoSocio(buffer) {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelConectarApi'
                    )
                });
                return;
            }

            if (this.usuarioLogado) {
                try {
                    subscribe(
                        `${this.usuarioLogado.idKeyCloack}/exportar/pdf/diagnostico/socio`,
                        response => {
                            if (response) {
                                const linkSource = `data:application/pdf;base64,${response}`;
                                const link = document.createElement('a');
                                const fileName =
                                    'diagnosticos-socioambientais.pdf';

                                const currentDate = new Date();
                                const formattedDate = `${currentDate.getFullYear()}${String(
                                    currentDate.getMonth() + 1
                                ).padStart(2, '0')}${String(
                                    currentDate.getDate()
                                ).padStart(2, '0')}`;
                                const formattedTime = `${String(
                                    currentDate.getHours()
                                ).padStart(2, '0')}${String(
                                    currentDate.getMinutes()
                                ).padStart(2, '0')}${String(
                                    currentDate.getSeconds()
                                ).padStart(2, '0')}`;

                                const newFileName = fileName.replace(
                                    '.pdf',
                                    `-${formattedDate}-${formattedTime}.pdf`
                                );

                                link.href = linkSource;
                                link.download = newFileName;
                                link.click();
                                link.remove();
                            } else {
                                this.$notify.error({
                                    message: this.$t(
                                        'mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelExportarPdf'
                                    )
                                });
                            }
                            this.loadingPDF = false;
                            disconnect();
                        }
                    );
                    this.loadingPDF = true;
                    const idTerritorio = this.$route.params.idTerritorio;
                    const params = {
                        idTerritorio,
                        tipoDocumento: 'TERRITORIO',
                        camadas: this.camadasAtivas,
                        buffer: buffer
                            ? JSON.stringify(this.territorio.buffer.geometria)
                            : null,
                        cars: !!this.dadosCar.length
                    };

                    const dados = [];
                    dados.push(params);

                    retryOperation(
                        DiagnosticoSocioambientalService.exportarPdf,
                        dados,
                        5000,
                        10
                    );
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelExportarPdf'
                        )
                    });
                    disconnect();
                }
            } else {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.usuarioDeslogado'
                    )
                });
                disconnect();
            }
        },

        alterarNomeCamada(dadosCar) {
            dadosCar.forEach(dadoCar => {
                dadoCar.diagnosticos.forEach(diagnostico => {
                    if (diagnostico.camada.nome === 'Áreas embargadas') {
                        diagnostico.camada.nome = this.$t(
                            'mensagens.camadas.AREA_EMBARGADA'
                        );
                    }
                });
            });

            return dadosCar;
        },

        ordenarDiagnosticoPorCamada(diagnosticos) {
            return sortBy(diagnosticos, [
                diagnostico => diagnostico.camada.codigo
            ]);
        },

        atualizarRestricaoMapa(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];

            const tagRestricaoRemove = `${this.indexUltimaRestricaoAbertaTerritorio}-territorio`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );

            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaTerritorio = indexCollapseRow;
                this.areasRestricao = {
                    areas: this.territorio.diagnosticos[indexCollapseRow]
                        .geometria,
                    camada: this.territorio.diagnosticos[indexCollapseRow]
                        .camada
                };

                const tagRestricaoAdd = `${indexCollapseRow}-territorio`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                const name = `AreaDiagnostico_red_${indexCollapse}_${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    name,
                    restricao
                );
            }
        },

        atualizarRestricaoBufferMapa(
            restricao,
            indexCollapse,
            indexCollapseRow
        ) {
            this.areasRestricao = [];

            const tagRestricaoRemove = `${this.indexUltimaRestricaoAbertaTerritorioBuffer}-territorio`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );

            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaTerritorioBuffer =
                    indexCollapseRow;
                this.areasRestricao = {
                    areas: this.territorio.buffer.diagnosticos[
                        indexCollapseRow
                    ].resultados.map(
                        resultado => resultado.geometry || resultado.geometria
                    ),
                    camada: this.territorio.buffer.diagnosticos[
                        indexCollapseRow
                    ].camada
                };

                const tagRestricaoAdd = `${indexCollapseRow}-territorio`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                const name = `AreaDiagnostico_red_${indexCollapse}_${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    name,
                    restricao
                );
            }
        },

        atualizarRestricaoMapaCpf(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];

            const indexTagRemove =
                this.indexUltimaRestricaoAbertaRepresentante != null
                    ? this.indexUltimaRestricaoAbertaRepresentante
                    : indexCollapseRow;
            const tagRestricaoRemove = `${indexCollapse}-representante-${indexTagRemove}`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );

            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaRepresentante = indexCollapseRow;

                if (
                    this.representantes[indexCollapse].diagnostico[
                        indexCollapseRow
                    ]
                ) {
                    this.areasRestricao = {
                        areas: this.representantes[indexCollapse].diagnostico[
                            indexCollapseRow
                        ].resultados.map(
                            resultado =>
                                resultado.geometria || resultado.geometry
                        ),
                        camada: this.representantes[indexCollapse].diagnostico[
                            indexCollapseRow
                        ].camada
                    };
                }

                const tagRestricaoAdd = `${indexCollapse}-representante-${indexCollapseRow}`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                const name = `AreaDiagnostico_red_${indexCollapse}_${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    name,
                    restricao
                );
            }
        },

        atualizarRestricaoMapaCars(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];

            const indexTagRemove =
                this.indexUltimaRestricaoAbertaCar !== null
                    ? this.indexUltimaRestricaoAbertaCar
                    : indexCollapseRow;
            const tagRestricaoRemove = `${indexCollapse}-car-${indexTagRemove}`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );
            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaCar = indexCollapseRow;
                if (
                    this.dadosCar[indexCollapse].diagnosticos[indexCollapseRow]
                ) {
                    this.areasRestricao = {
                        areas: this.dadosCar[indexCollapse].diagnosticos[
                            indexCollapseRow
                        ].resultados.map(
                            resultado =>
                                resultado.geometria || resultado.geometry
                        ),
                        camada: this.dadosCar[indexCollapse].diagnosticos[
                            indexCollapseRow
                        ].camada
                    };
                }

                const tagRestricaoAdd = `${indexCollapse}-car-${indexCollapseRow}`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                const name = `AreaDiagnostico_red_${indexCollapse}_${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    name,
                    restricao
                );
            }
        },

        marcarExportacaoDiagnosticPdf() {
            const documento = {
                idLista: Math.floor(Date.now() * Math.random()).toString(36),
                idTerritorio: this.$route.params.idTerritorio,
                nome: this.territorio.dadosTerritorio.nome,
                tipoDocumento: 'TERRITORIO',
                documento: null,
                camadas: this.camadasAtivas,
                buffer: this.territorio.buffer
                    ? JSON.stringify(this.territorio.buffer.geometria)
                    : null,
                cars: !!this.dadosCar.length
            };

            this.setMarcarExportar_PDF(documento);
        },

        async buscarDiagnosticoTerritorio(idTerritorio) {
            try {
                const { data } = await TerritorioService.findById(idTerritorio);
                this.territorio.dadosTerritorio = data;
                this.configureLayersMapa();
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.ocorreuErroAoBuscarDadosDiagnostico'
                    )
                });
            }
        },

        buscarDiagnosticoCars() {
            this.fecharTodosCollapsesAbertos();

            DiagnosticoSocioambientalService.buscarDiagnosticoCarDoTerritorio(
                this.territorio
            )
                .then(responses => {
                    this.carsVinculadosLayersMapa(responses);
                    this.dadosCar = responses.map(response => ({
                        imovel: response.imovel,
                        diagnosticos: response.diagnosticos.map(d => ({
                            camada: { ...d.camada, opacidade: 100 },
                            nivelAlerta: d.nivelAlerta,
                            resultados: d.resultados
                        }))
                    }));

                    this.dadosCar = this.alterarNomeCamada(this.dadosCar);
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelBuscarDiagnosticoSocioambientalCar'
                        )
                    });
                });
        },

        async buscarDiagnosticoRepresentantes(idTerritorio) {
            try {
                const { data } =
                    await TerritorioService.diagnosticoSocioambiental(
                        idTerritorio
                    );
                this.representantes = data.diagnosticoPorRepresentante.map(
                    representante => ({
                        documento: representante.documento,
                        nomeRepresentante: representante.nomeRepresentante,

                        diagnostico: representante.diagnostico.map(r => ({
                            camada: { ...r.camada, opacidade: 100 },
                            nivelAlerta: r.nivelAlerta,
                            resultados: r.resultados
                        }))
                    })
                );

                this.informacoes_gerais = data.informacoes_gerais;
                this.territorio.idDiagnosticoSocioambiental =
                    data.idDiagnosticoSocioambiental;
                this.territorio.diagnosticos = data.responseDiagnosticos.map(
                    r => ({
                        camada: { ...r.camada, opacidade: 100 },
                        nivelAlerta: r.nivelAlerta,
                        resultados: r.resultados.map(r => r.properties),
                        geometria: r.resultados.map(
                            r => r.geometria || r.geometry
                        )
                    })
                );

                this.territorio.diagnosticos.sort((a, b) => {
                    return a.camada.nome.localeCompare(b.camada.nome);
                });

                Object.keys(this.territorio.diagnosticos).forEach(item => {
                    if (
                        this.territorio.diagnosticos[item].camada.nome ===
                        'Áreas embargadas'
                    ) {
                        this.territorio.diagnosticos[item].camada.nome =
                            this.$t('mensagens.camadas.AREA_EMBARGADA');
                    }
                });

                Object.keys(this.representantes).forEach(itemRepresentante => {
                    Object.keys(this.representantes).forEach(i => {
                        if (
                            this.representantes[itemRepresentante].diagnostico[
                                i
                            ].camada.nome === 'Áreas embargadas'
                        ) {
                            this.representantes[itemRepresentante].diagnostico[
                                i
                            ].camada.nome = this.$t(
                                'mensagens.camadas.AREA_EMBARGADA'
                            );
                        }
                    });
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.erroAoBuscarDadosPessoas'
                    )
                });
            }
        },

        formatNumber(input, decimalPlaces) {
            return formatters.formatNumber(input, decimalPlaces);
        }
    }
};
</script>

<style lang="scss">
#diagnostico-socioambiental-territorio-view {
    display: flex;
    flex-direction: row;
    height: 100%;
    border-radius: 4px;
    overflow: hidden;

    .spaceProximidades {
        margin-top: 5px;
    }

    .card-socioambiental {
        width: 700px;
        background-color: var(--white);
        border: 0;

        padding: 16px;
        overflow: auto;

        header {
            h1 {
                margin-left: 2px;
                margin-bottom: 16px;
            }

            .voltar {
                margin-left: -10px;
                margin-right: 5px;
            }

            .voltar:hover {
                cursor: pointer;
            }
        }

        .dados {
            min-height: 700px;
        }

        .dados-label {
            margin-bottom: 5px;
            b {
                padding-left: 5px;
            }
        }
    }

    @media (max-width: 900px) {
        #diagnostico-socioambiental-view {
            flex-direction: column;
        }

        .card-socioambiental {
            height: 400px;
            width: 100%;
            .vazio {
                height: 60px;
            }
        }
    }

    .downloadMenu {
        min-width: 180px;
    }

    .el-dropdown-link-exportar {
        border: 1px solid #babac9;
        padding: 10px 20px;
        color: #19194b;
        border-radius: 5px;
        cursor: pointer;
        font-weight: 500;
        font-size: 13px !important;
    }

    .el-dropdown-link-exportar:hover {
        background-color: #e8e8ed;
    }

    .downloadButton {
        background: transparent !important;
        border: none !important;
        text-align: left !important;
        padding: 0 !important;
    }

    .exportar-btn {
        display: flex;
        justify-content: space-between;
    }

    .buscarCars {
        button {
            background: transparent !important;
            border: none !important;
            padding: 0;
            color: blue;
            text-decoration: underline;
        }
    }

    .informacoes-gerais {
        font-size: 13px !important;
        height: 25px !important;
        font-weight: 500;
    }
    .tela-cheia:has(#add-new-territorio) {
        height: auto;
        width: calc(100vw - 40px - 70px);
    }
}
.tela-cheia:has(#add-new-territorio) {
    height: auto;
    width: calc(100vw - 40px - 70px);
}
</style>
